<template>
  <div>
    <div class="row g-2">
      <div class="col-md-5">
        <select class="form-select form-select-sm" :value="type" @change="onTypeChange($event.target.value)">
          <option v-for="(label, key) in linkTypes" :key="key" :value="key">{{ label }}</option>
        </select>
      </div>
      <div class="col-md-7">
        <select v-if="type === 'category'" class="form-select form-select-sm" :value="value" @change="emitValue($event.target.value)">
          <option value="">Select category</option>
          <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
        </select>
        <select v-else-if="type === 'brand'" class="form-select form-select-sm" :value="value" @change="emitValue($event.target.value)">
          <option value="">Select brand</option>
          <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.name }}</option>
        </select>
        <input v-else-if="type === 'search'" type="text" class="form-control form-control-sm" :value="value" maxlength="100"
               placeholder="Search term, e.g. milk" @input="emitValue($event.target.value)">
        <input v-else-if="type === 'url'" type="text" class="form-control form-control-sm" :value="value" maxlength="255"
               placeholder="https://... or /shop?..." @input="emitValue($event.target.value)">
        <div v-else-if="type === 'product'">
          <div v-if="value && productName" class="d-flex align-items-center gap-2 small">
            <i class="bi bi-box-seam"></i><span class="text-truncate flex-grow-1">{{ productName }}</span>
            <button type="button" class="btn btn-sm btn-link p-0" @click="emitValue('')">Change</button>
          </div>
          <ProductPicker v-else :model-value="[]" :max="1" @update:model-value="onProductPicked" ref="picker" />
        </div>
      </div>
    </div>
    <small v-if="type === 'url' && value && !isSafeUrl" class="text-danger">Use a link that starts with https://, http:// or /</small>
  </div>
</template>

<script>
import ProductPicker from "./ProductPicker.vue";
import { LINK_TYPES } from "../storefrontMeta";

export default {
  name: "LinkEditor",

  components: { ProductPicker },

  emits: ['update:type', 'update:value'],

  props: {
    type: { type: String, default: 'none' },
    value: { type: String, default: '' },
    categories: { type: Array, default: () => [] },
    brands: { type: Array, default: () => [] },
  },

  data() {
    return {
      linkTypes: LINK_TYPES,
      productName: this.value ? 'Selected product' : '',
    }
  },

  computed: {
    isSafeUrl() {
      return /^(https?:\/\/[^\s<>"']+|\/[^\s<>"']*)$/i.test(this.value || '')
    },
  },

  methods: {
    onTypeChange(type) {
      this.$emit('update:type', type)
      this.$emit('update:value', '')
      this.productName = ''
    },
    emitValue(value) {
      if (!value) this.productName = ''
      this.$emit('update:value', value)
    },
    onProductPicked(ids) {
      if (!ids.length) return
      const known = this.$refs.picker?.known?.[ids[0]]
      this.productName = known?.name || 'Selected product'
      this.$emit('update:value', ids[0])
    },
  },
}
</script>
